import { devtools, subscribeWithSelector } from "zustand/middleware";
import { DEVTOOLS_ENABLED } from "../consts";
import { create } from "../feat/appState/resetState";
import { createBookingSlice } from "./bookingState/booking.context";
import { IBookingSlice } from "./bookingState/booking.interfaces";
import { createFormFieldPickerSlice, FormFieldPickerSlice } from "./formFieldPicker.slice";
import { createMapSlice, IMapSlice } from "./map.slice";
import { createPageStateSlice, IPageStateSlice } from "./pageState/pageState.slice";
import { createExpenseAIResultSlice, ExpenseAIResultSlice } from "./expenseAIResult.slice";

export interface EphemeralStore
  extends IBookingSlice, IMapSlice, IPageStateSlice, FormFieldPickerSlice, ExpenseAIResultSlice {}

/**
 * A store that uses has no persistence.
 */
export const useEphemeralStore = create<EphemeralStore>()(
  subscribeWithSelector(
    devtools(
      (...a) => ({
        ...createBookingSlice(...a),
        ...createMapSlice(...a),
        ...createPageStateSlice(...a),
        ...createFormFieldPickerSlice(...a),
        ...createExpenseAIResultSlice(...a),
      }),
      { enabled: DEVTOOLS_ENABLED },
    ),
  ),
);

// alias for convenience
export const es = useEphemeralStore.getState;
